export default __webpack_public_path__ + "static/media/Slider image 03.b93bbe4a.PNG";